/* eslint-disable react/no-multi-comp */
import * as auth from '../_redux/authRedux';
import { Avatar, Typography, TextField, Checkbox, FormControl, FormHelperText, FormControlLabel } from '@material-ui/core';
import { Button, Alert } from 'rsuite';
import { Link } from 'react-router-dom';
import { register } from '../_redux/authCrud';
import { connect } from 'react-redux';
import IconAccountCircle from '@material-ui/icons/AccountCircle';
import React, { useState } from 'react';

function MyTextField ({ id, name, label, value, error = '', setValue, setError, ...extra }) {
    const onChange = (event) => {
        const value = event.target.value;
        setValue(value);
        setError('');
    };

    return (
        <TextField
            id={id || name}
            name={name || id}
            label={label}
            value={value}
            error={!!error.trim()}
            helperText={error}
            variant="outlined"
            fullWidth
            onChange={onChange}
            {...extra}
        />
    );
}

function MyCheckbox ({ id, name, value, error = '', setValue, setError, className, children }) {
    const onChange = (event) => {
        const value = event.target.checked;
        setValue(value);
        setError('');
    };

    return (
        <FormControl
            className={className}
            error={true}
        >
            <FormControlLabel
                label={children}
                control={
                    <Checkbox
                        color="primary"
                        id={id}
                        name={name}
                        checked={value}
                        onChange={onChange}
                    />
                }
            />
            <FormHelperText>
                {error}
            </FormHelperText>
        </FormControl>
    );
}

function MyLink ({ to, children }) {
    return (
        <Link
            to={to}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </Link>
    );
}

export function Register (props) {
    const [loading, setLoading] = useState(false);

    const [fullname, setFullname] = useState('');
    const [fullnameError, setFullnameError] = useState('');

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    const [username, setUsername] = useState('');
    const [usernameError, setUsernameError] = useState('');

    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [passwordConfirmError, setPasswordConfirmError] = useState('');

    const [acceptTerms, setAcceptTerms] = useState(false);
    const [acceptTermsError, setAcceptTermsError] = useState('');

    const submit = async (event) => {
        event.preventDefault();
        setLoading(true);

        // Validation

        let error = false;

        // fullname is required
        // fullname must have at least 3 characters
        // fullname must have at most 50 characters
        if (!fullname.trim()) {
            error = true;
            setFullnameError('Este campo es obligatorio');
        }
        else if (fullname.trim().length <= 3) {
            error = true;
            setFullnameError('El nombre no puede tener menos de 3 caracteres');
        }
        else if (fullname.trim().length > 50) {
            error = true;
            setFullnameError('El nombre no puede tener mas de 50 caracteres');
        }

        // email is required
        // email must be an email
        // email must have at least 3 characters
        // email must have at most 50 characters
        if (!email.trim()) {
            error = true;
            setEmailError('Este campo es obligatorio');
        }
        else if (email.trim().length <= 3) {
            error = true;
            setEmailError('El nombre no puede tener menos de 3 caracteres');
        }
        else if (email.trim().length > 50) {
            error = true;
            setEmailError('El nombre no puede tener mas de 50 caracteres');
        }

        // username is required
        // username must have at least 3 characters
        // username must have at most 50 characters
        if (!username.trim()) {
            error = true;
            setUsernameError('Este campo es obligatorio');
        }
        else if (username.trim().length <= 3) {
            error = true;
            setUsernameError('El nombre no puede tener menos de 3 caracteres');
        }
        else if (username.trim().length > 50) {
            error = true;
            setUsernameError('El nombre no puede tener mas de 50 caracteres');
        }

        // password is required
        // password must have at least 3 characters
        // password must have at most 50 characters
        if (!password.trim()) {
            error = true;
            setPasswordError('Este campo es obligatorio');
        }
        else if (password.trim().length <= 3) {
            error = true;
            setPasswordError('El nombre no puede tener menos de 3 caracteres');
        }
        else if (password.trim().length > 50) {
            error = true;
            setPasswordError('El nombre no puede tener mas de 50 caracteres');
        }

        // passwordConfirm is required
        // passwordConfirm must match password
        // acceptTerms must be true
        if (!passwordConfirm.trim()) {
            error = true;
            setPasswordConfirmError('Este campo es obligatorio');
        }
        else if (password.trim() !== passwordConfirm.trim()) {
            error = true;
            setPasswordConfirmError('Las contraseñas no coinciden');
        }

        // acceptTerms must be true
        if (!acceptTerms) {
            error = true;
            setAcceptTermsError('Tenes que aceptar los terminos y condiciones');
        }

        if (error) {
            setLoading(false);
            return false;
        }

        // Registration
        try {
            const response = await register(email, fullname, username, password);
            const accessToken = response.data.accessToken;
            props.register(accessToken);
            Alert.success('Tus datos se guardaron correctamente!');
        }
        catch (error) {
            Alert.error('Lo sentimos, no pudimos completar tu registro. Por favor, intentalo de nuevo mas tarde.');
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <Avatar>
                <IconAccountCircle />
            </Avatar>
            <Typography component="h1" variant="h5">
                Registrarme
            </Typography>
            <form noValidate onSubmit={submit}>
                <MyTextField
                    name="fullname" label="Nombre Completo"
                    value={fullname} setValue={setFullname}
                    error={fullnameError} setError={setFullnameError}
                    autoFocus
                />
                <MyTextField
                    name="email" label="Email"
                    value={email} setValue={setEmail}
                    error={emailError} setError={setEmailError}
                />
                <MyTextField
                    name="username"
                    label="Usuario"
                    value={username} setValue={setUsername}
                    error={usernameError} setError={setUsernameError}
                />
                <MyTextField
                    name="password"
                    label="Contraseña"
                    type="password"
                    value={password} setValue={setPassword}
                    error={passwordError} setError={setPasswordError}
                />
                <MyTextField
                    name="password-confirm"
                    label="Confirmar Contraseña"
                    type="password"
                    value={passwordConfirm} setValue={setPasswordConfirm}
                    error={passwordConfirmError} setError={setPasswordConfirmError}
                />
                <MyCheckbox
                    name="acceptTerms"
                    value={acceptTerms} setValue={setAcceptTerms}
                    error={acceptTermsError} setError={setAcceptTermsError}
                >
                    Estoy de acuerdo con los{' '}<MyLink to="/terms">Terminos y Condiciones</MyLink>.
                </MyCheckbox>
                <Button type="submit" appearance='primary' block loading={loading}>
                    Registrarme
                </Button>
            </form>
        </div>
    );
}

export default connect(null, auth.actions)(Register);
